(function (angular) {
    'use strict';

    angular.module('channels')

        /**
         *
         */
        .factory('smsChannelService',
            [ '$uibModal',
                function ( $uibModal) {
                

                    var fac = {
                        getNumbersConfig: getNumbersConfig,
                        getTrackingConfig: getTrackingConfig
                    };

                    return fac;
                
                    function getTrackingConfig() {
                        return $uibModal.open({
                            templateUrl: 'components/channels/sms/templates/tracking.html',
                            size: 'lg',
                            resolve: {
                                trackingData: ['$q', '$stateParams', 'trackingService', function ($q, $stateParams, trackingService) {
                                    return trackingService.getAllTrackingData($stateParams.pickedApiSpaceId)
                                        .then(function (result) {
                                            return result;
                                        }).catch(function (result) {
                                            var deferred = $q.defer();
                                            if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                            return deferred.promise;
                                        });
                                }]
                            },
                            controller: 'trackingCtrl'
                        });

                    }
                
                    function getNumbersConfig() {
                        return $uibModal.open({
                            templateUrl: 'components/channels/sms/templates/inbound.html',
                            size: 'lg',
                            resolve: {
                                dedicatedNumbers: ['$q', '$stateParams', 'inboundService', function ($q, $stateParams, inboundService) {
                                    return inboundService.getDedicatedNumbers($stateParams.pickedApiSpaceId)
                                        .then(function (result) {
                                            return result;
                                        }).catch(function (result) {
                                            var deferred = $q.defer();
                                            if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                            return deferred.promise;
                                        });
                                }],
                                keywords: ['$q', '$stateParams', 'inboundService', function ($q, $stateParams, inboundService) {
                                    return inboundService.getKeywords($stateParams.pickedApiSpaceId)
                                        .then(function (result) {
                                            return result;
                                        }).catch(function (result) {
                                            var deferred = $q.defer();
                                            if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                            return deferred.promise;
                                        });
                                }],
                                shortcodes: ['$q', '$stateParams', 'inboundService', function ($q, $stateParams, inboundService) {
                                    return inboundService.getShortcodes($stateParams.pickedApiSpaceId)
                                        .then(function (result) {
                                            return result;
                                        }).catch(function (result) {
                                            var deferred = $q.defer();
                                            if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                            return deferred.promise;
                                        });
                                }],
                                countries: ['$q', 'coreDataService', function ($q, coreDataService) {
                                    return coreDataService.getCountries()
                                        .then(function (result) {
                                            return result;
                                        }).catch(function (result) {
                                            var deferred = $q.defer();
                                            if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                            return deferred.promise;
                                        });
                                }]
                            },
                            controller: 'inboundCtrl'
                        });
                }

            }]);

})(window.angular);